import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const faqs = [
  { q: "Where do you deliver?", a: "We currently deliver across select pincodes in Ghaziabad. Enter yours at checkout to confirm." },
  { q: "How fresh is it?", a: "Every product is made the same day it reaches you. Best enjoyed within 24 hours, refrigerated." },
  { q: "How is it packaged?", a: "Every order arrives in a kraft carry bag with a thank-you card, wooden spoons and tissue. Direct website orders often include a complimentary cookie." },
  { q: "Do you have eggless options?", a: "Our Traditional Italian uses egg yolks in the classical style. Each product is clearly labelled — please pick whichever suits you best." },
  { q: "How do I pay?", a: "Online via UPI, cards or netbanking through our secure payment partner. Delivery is confirmed only after successful payment." },
  { q: "Can I schedule an order?", a: "Yes — pick a delivery or pickup slot at checkout. ASAP is offered when the kitchen has capacity." },
  { q: "Do you take corporate or bulk orders?", a: "Yes — please head to our Bulk Orders page (10 cups and above) or email hello@tiramisuandco.in and we'll be right back with a boutique quote." },
];

export default function Faq() {
  return (
    <main data-testid="faq-page" className="max-w-[900px] mx-auto px-6 md:px-10 py-16 md:py-24">
      <div className="label-xs text-espresso-light">FAQ</div>
      <h1 className="mt-3 font-serif text-5xl md:text-7xl leading-[0.95] tracking-tight text-espresso">
        Gently addressed.
      </h1>
      <Accordion type="single" collapsible className="mt-14">
        {faqs.map((f, i) => (
          <AccordionItem value={`item-${i}`} key={i} className="border-b border-line">
            <AccordionTrigger className="font-serif text-xl md:text-2xl text-espresso py-5 hover:no-underline text-left">
              {f.q}
            </AccordionTrigger>
            <AccordionContent className="text-espresso-light leading-relaxed pb-6">
              {f.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </main>
  );
}
